import * as React from 'react';

import CTAContentful from 'bundles/coursera-plus-landing-page/components/ctaContentful/CTAContentful';
import { CTA_LOCATIONS } from 'bundles/coursera-plus-landing-page/contentful/constants';
import { useLandingPageExtended } from 'bundles/coursera-plus-landing-page/contentfulData/useLandingPageData';

type PropsToComponent = {
  areaId: number;
};

const DesignArea = (props: PropsToComponent) => {
  const landingPageExtended = useLandingPageExtended();
  const allCtaParts = landingPageExtended.landingPage?.heroCtaPartsCollection?.items ?? [];
  const displayedCtaParts = allCtaParts.filter((item) => {
    if (!item) {
      return false;
    }
    const area = item.area ?? 1;
    return area === props.areaId;
  });
  return (
    <div>
      <CTAContentful ctaPieces={displayedCtaParts} ctaLocation={CTA_LOCATIONS.hero} />
    </div>
  );
};

export default DesignArea;
